/**
 * Valuation Lines Indicator
 *
 * Wraps the valuationLines calculator and merges results into chart data.
 * Outputs 7 horizontal levels based on visible data statistics:
 * - average: Mean/median/harmonic average of visible data
 * - plusOneStdDev, minusOneStdDev: ±1 standard deviation
 * - plusTwoStdDev, minusTwoStdDev: ±2 standard deviations
 * - plusThreeStdDev, minusThreeStdDev: ±3 standard deviations
 *
 * Key feature: Values recalculate based on visible chart range (dynamic with zoom/pan)
 */

import { rebind, merge } from "../utils";
import { valuationLines } from "../calculator";
import baseIndicator from "./baseIndicator";

const ALGORITHM_TYPE = "ValuationLines";

export default function () {
  const base = baseIndicator()
    .type(ALGORITHM_TYPE)
    .accessor((d) => d.valuationLines);

  const underlyingAlgorithm = valuationLines();

  const mergedAlgorithm = merge()
    .algorithm(underlyingAlgorithm)
    .merge((datum, indicator) => {
      datum.valuationLines = indicator;
    });

  const indicator = function (data, options = { merge: true }) {
    if (options.merge) {
      if (!base.accessor())
        throw new Error(
          `Set an accessor to ${ALGORITHM_TYPE} before calculating`,
        );
      return mergedAlgorithm(data);
    }
    return underlyingAlgorithm(data);
  };

  rebind(indicator, base, "id", "accessor", "stroke", "fill", "echo", "type");
  rebind(indicator, underlyingAlgorithm, "options", "undefinedLength");
  rebind(indicator, mergedAlgorithm, "merge", "skipUndefined");

  return indicator;
}
